import { render, staticRenderFns } from "./questionType15.vue?vue&type=template&id=082e7580"
import script from "./questionType15.vue?vue&type=script&lang=js"
export * from "./questionType15.vue?vue&type=script&lang=js"
import style0 from "./questionType15.vue?vue&type=style&index=0&id=082e7580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports